import React from "react";

const LogInPageSkeleton = () => {
  return (
    <div className="w-screen h-screen p-6 bg-color1 grid grid-cols-3 grid-rows-1">
      {/* Left Side */}
      <div className="col-span-2 flex flex-col items-start w-full">
        {/* Logo */}
        <div className="h-[45px] w-32 bg-color2 rounded mb-3"></div>

        {/* Clock */}
        <div className="h-5 w-24 bg-color2 rounded mb-6"></div>

        {/* Buttons */}
        <div className="mt-10 flex gap-4">
          <div className="h-8 w-28 bg-color2 rounded"></div>
          <div className="h-8 w-24 bg-color2 rounded"></div>
          <div className="h-8 w-32 bg-color2 rounded"></div>
        </div>

        {/* Staff list */}
        <div className="mt-4 w-full h-full flex flex-wrap gap-2 pt-4 overflow-auto">
          {Array.from({ length: 6 }).map((_, i) => (
            <div
              key={i}
              className="h-20 w-40 bg-color2 rounded-md flex flex-col justify-center items-center"
            >
              <div className="h-4 w-20 bg-color3 rounded mb-2"></div>
              <div className="h-3 w-16 bg-color3 rounded"></div>
            </div>
          ))}
        </div>

        {/* Contact Info */}
        <div className="mt-10 flex flex-col gap-3">
          <div className="h-4 w-60 bg-color2 rounded"></div>
          <div className="h-4 w-60 bg-color2 rounded"></div>
          <div className="h-4 w-64 bg-color2 rounded"></div>
        </div>
      </div>

      {/* Right Side */}
      <div className="col-span-1 flex flex-col bg-color2 rounded-md p-4 items-center">
        {/* User Info */}
        <div className="h-[20px] w-32 bg-color1 rounded mt-4"></div>

        {/* Keypad */}
        <div className="w-48 h-48 bg-color1 rounded mt-6"></div>

        {/* Action Buttons */}
        <div className="flex gap-2 mt-6">
          <div className="h-8 w-20 bg-color1 rounded"></div>
          <div className="h-8 w-20 bg-color1 rounded"></div>
        </div>
      </div>
    </div>
  );
};

export default LogInPageSkeleton;
